module.exports = "<gallery rows.bind=\"galleryRows\"></gallery>\n"